import React, { useState } from 'react';
import api from '../services/api';
import './HannyaLogin.css';

function HannyaLogin({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await api.login(username, password);
      
      if (response.token) {
        localStorage.setItem('hannyaAuth', 'true');
        localStorage.setItem('hannyaToken', response.token);
        localStorage.setItem('hannyaUser', JSON.stringify(response.user));
        onLogin();
      } else {
        setError(response.message || 'Credenciais inválidas');
      }
    } catch (err) {
      setError(err.message || 'Erro de conexão com o servidor');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hannya-login-container">
      <div className="hannya-login-bg">
        <div className="hannya-login-card">
          <div className="hannya-login-header">
            <div className="hannya-logo">Survows</div>
            <span className="hannya-badge">✦ Área administrativa</span>
            <h1>Acesso restrito</h1>
            <p>Informe suas credenciais para continuar</p>
          </div>

          <form onSubmit={handleSubmit} className="hannya-login-form">
            {error && (
              <div className="hannya-error">
                <i className="fas fa-exclamation-triangle"></i>
                <span>{error}</span>
              </div>
            )}

            <div className="hannya-form-group">
              <label><i className="fas fa-user"></i> Usuário</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Digite seu usuário"
                required
                autoComplete="username"
              />
            </div>

            <div className="hannya-form-group">
              <label><i className="fas fa-lock"></i> Senha</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Digite sua senha"
                required
                autoComplete="current-password"
              />
            </div>

            <button 
              type="submit" 
              className="hannya-login-btn"
              disabled={loading}
            >
              {loading ? (
                <><i className="fas fa-spinner fa-pulse"></i> Entrando...</>
              ) : (
                <><i className="fas fa-sign-in-alt"></i> Entrar</>
              )}
            </button>
          </form>

          <div className="hannya-login-footer">
            <p><i className="fas fa-shield-alt"></i> Ambiente seguro e criptografado</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HannyaLogin;
